import React from 'react';
import cx from 'classnames';
import { get } from 'lodash/object';

import { TASKS_TYPES } from 'components/root/Container/Layout/Tasks/Task/taskConstants';
import { resolveTaskPriorityParams } from 'components/root/Container/Layout/Tasks/Task/taskServices';

import { APPOINTMENT_TYPES, MILESTONE_TYPES } from '../../CalendarEventType';

import './EventTypeIndicator.scss';

export default function EventTypeIndicator({ event, className }) {
  let style = {};
  if (APPOINTMENT_TYPES.includes(event.type)) {
    style = {
      backgroundColor: get(event, 'color.main', ''),
      borderRadius: '20px'
    };
  }
  if (TASKS_TYPES.includes(event.type)) {
    style = {
      backgroundColor: 'transparent',
      borderColor: get(event, 'color.main', ''),
      borderRadius: '20px'
    };
  }
  if (MILESTONE_TYPES.includes(event.type)) {
    style = {
      backgroundColor: get(event, 'color.main', '')
    };
  }

  const { TaskIcon } = resolveTaskPriorityParams(event?.priority?.priority) || {};

  return TaskIcon ? (
    <div className={cx('eds-event-type-priority-indicator', className)}>
      <TaskIcon
        sx={{
          fontSize: '13px',
          color: get(event, 'color.main', ''),
          stroke: get(event, 'color.main', ''),
          strokeWidth: 2
        }}
      />
    </div>
  ) : (
    <div className={cx('eds-event-type-indicator', className)} style={style} />
  );
}
